export default "__VITE_ASSET__CEb8lncn__"